import * as React from 'react'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'

import styles from './index.module.scss'

interface Props {
  label: string
  tooltip?: string
}

const Row = ({ label, tooltip, children }: React.PropsWithChildren<Props>) => {
  const renderTooltip = () => {
    if (!tooltip) return null

    return (
      <div className={styles.tooltip}>
        <InformationTooltip information={tooltip} />
      </div>
    )
  }

  return (
    <div className={styles.row}>
      <div className={styles.label}>
        {label}
        {renderTooltip()}
      </div>
      <div className={styles.value}>{children}</div>
    </div>
  )
}

export default observer(Row)
